export const environment = {
    authUrl: 'https://qa.auth.depositionprep.io',
    apiUrl: '',
    production: false,
    clientPortalUrl: 'https://qa.client.depositionprep.io',
    stripePublishableKey: 'pk_test_51RRmMiRXtXoiGb3cvzoauG85JhC89bfOpnsJ9sCi2gLMyn1EjINBNVrF2SAOHhd2t07j5pMk67fn9FDvfK17vkKz00m1W7bJXw'
};
